import { useQuery } from "react-query";
import { getCarrierEAndOSubmissionType } from "../../../../actions/CarrierAgreementMgmt/Carrier";

export const useGetCarrierEAndOSubmissionType = () => {
  return useQuery(
    "GetCarrierEAndOSubmissionType",
    getCarrierEAndOSubmissionType,
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );
};
